import React from 'react'
import copy from './copy'
import { useHandleCopyValue } from '@sketch/modules-common'
import {
  AttributeList,
  FullCopyAttribute,
  Blend,
  CollapsibleInspectorSection,
} from '../../components'
import { LayerAppearance } from '../../../../../../inspector'
import { ReactComponent as RectanglesIcon } from '@sketch/icons/rectangles-2-17'

type AppearanceProps = {
  appearance: LayerAppearance
}

export const Appearance: React.FC<AppearanceProps> = ({ appearance }) => {
  const { blendMode, opacity } = appearance
  const opacityPercentage = `${(opacity * 100).toFixed().toLocaleString()}%`

  const sectionCopyValue = copy({
    opacityPercentage,
    blendMode,
  })

  const { handleCopyValue, copyTooltipText } =
    useHandleCopyValue(sectionCopyValue)

  return (
    <CollapsibleInspectorSection
      title="Appearance"
      data-testid="inspector-sidebar-appearance"
      actions={[
        {
          icon: <RectanglesIcon width={17} height={17} />,
          tooltipText: copyTooltipText,
          onClick: handleCopyValue,
        },
      ]}
    >
      <AttributeList>
        <FullCopyAttribute
          label="Opacity"
          value={
            <>
              {opacityPercentage}
              {blendMode.toLowerCase() !== 'normal' && (
                <Blend blendMode={blendMode} />
              )}
            </>
          }
          copyValue={opacityPercentage}
        />
      </AttributeList>
    </CollapsibleInspectorSection>
  )
}
